import { type PurchasePathState } from '../../types/initialState';
import styles from '../CoverageSection/CoverageSection.module.scss';
import CoverageHeading from '../CoverageSelector/CoverageHeading';
import CoverageInfoModal from '../CoverageSelector/CoverageInfoModal';
import CoverageStepper from '../CoverageSelector/CoverageStepper';
import { CoverageProduct } from 'dto/marketableProduct';
import {
  useSelectedPremiums,
  useSelectablePremiums,
} from 'state/selectors/coverageSelectors';
import { getInitialState } from 'utils';

interface Props {
  displayDetails: boolean;
}

const PermanentDisability = ({ displayDetails }: Props) => {
  const { marketableProduct } = getInitialState() as PurchasePathState;
  const selectedSumInsuredPremiums = useSelectedPremiums();
  const permanentDisabilitySelectablePremiums = useSelectablePremiums(
    CoverageProduct.PERMANENT_DISABILITY
  );

  if (!permanentDisabilitySelectablePremiums) {
    // Return null to avoid error throwing on page refresh
    return null;
  }

  const coverage = marketableProduct.coverages.find(
    (c) => c.coverageProduct === CoverageProduct.PERMANENT_DISABILITY
  );

  if (!coverage) {
    throw new Error(
      `No coverage found for coverageProduct: ${CoverageProduct.PERMANENT_DISABILITY}`
    );
  }
  const permanentDisabilityPremium =
    selectedSumInsuredPremiums[CoverageProduct.PERMANENT_DISABILITY];

  if (!permanentDisabilityPremium) {
    return null;
  }

  return (
    <div
      data-testid={`coverageTile-${coverage.coverageProduct}`}
      className={styles.coverageTile}>
      <CoverageHeading
        coverage={coverage}
        premium={permanentDisabilityPremium}
        displayDetails={displayDetails}
      />
      {displayDetails && (
        <CoverageStepper
          coverage={coverage}
          premium={permanentDisabilityPremium}
          selectablePremiums={permanentDisabilitySelectablePremiums}
        />
      )}
      <CoverageInfoModal coverage={coverage} />
    </div>
  );
};

export default PermanentDisability;
